import "./Home.css"; // Ensure you create and import the CSS file for styles
import Collections from "./collections/Collections";
import Features from "./Feature/Features";
import Shapingd from "./shaping/ Shapingd";
import Footer from "../Footer/Footer";
import ExploreCollection from "./exploreCollection/ExploreCollection";
import Navbar from "./Navbar/Navbar";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

export default function Home() {
	const [data, setData] = useState([]);

	useEffect(() => {
		fetch("/data2026.json") // 👈 fetches from public folder
			.then((response) => {
				if (!response.ok) {
					throw new Error("Network response was not ok");
				}
				return response.json();
			})
			.then((data) => setData(data))
			.catch((error) => console.error("Error fetching data:", error));
	}, []);
	return (
		<div className="relative overflow-hidden">
			<Navbar  />
			<ExploreCollection />
			<Collections data={data} />
			<TypeDress title={"Shine Bright, Dance Bold."} data={data} />
			<TypeDress title={"Forever Starts with You."} data={data} />
			<TypeDress title={"Grace, Glamour, Timeless Beauty."} data={data} />
			<Features data={data} />
			<Shapingd />
			<Footer />
		</div>
	);
}

function TypeDress({ title, data = [] }) {
	const scrollRef = useRef(null);
	const randomdata = [...data].sort(() => 0.5 - Math.random()).slice(0, 10);

	const scroll = (direction) => {
		const container = scrollRef.current;
		if (!container) return;

		// 1. Get the first item (the card) inside the scroll container
		const firstItem = container.firstElementChild;
		if (!firstItem) return;

		const nextItem = firstItem.nextElementSibling;
		let scrollAmount = 0;

		if (nextItem) {
			// The distance from the container's left edge to the next item's left edge.
			// This automatically includes the item width (350px) and the gap (12px).
			scrollAmount = nextItem.offsetLeft - firstItem.offsetLeft;
		} else {
			// Fallback for when there's only one item or for safety
			scrollAmount = firstItem.offsetWidth + 16; // Fallback to hardcoded gap
		}

		// --- Execute Scroll ---
		if (direction === "left") {
			container.scrollLeft -= scrollAmount;
		} else {
			container.scrollLeft += scrollAmount;
		}
	};

	return (
		<div className="relative overflow-hidden mb-20">
			{/* Title */}
			<div className="text-center font-lora font-semibold text-3xl md:text-5xl mb-20">
				<h3>{title}</h3>
			</div>

			{/* Left Arrow */}
			<button
				onClick={() => scroll("left")}
				// ... (classes remain the same)
				className="absolute left-4 top-[60%] -translate-y-1/2 bg-[#1f4c94]  shadow-md p-2 rounded-full z-10 hover:bg-[#1f4c94] transition">
				<Icon icon="mdi:chevron-left" className="text-3xl text-white" />
			</button>

			{/* Scrollable Images */}
			<div
				ref={scrollRef}
				className="flex gap-3 overflow-x-auto px-4 scroll-smooth scrollbar-hide no-scrollbar">
				{randomdata.map((item, index) => (
					<Link
						to={`/product/id/${item.style}`}
						state={{
							product: item,
							url: `https://demo.riskydress.com/images/${item.year}/AZURE/`,
						}}
						key={index}
						// This class is the key to automatic width:
						className="relative w-[350px] h-[400px] flex-shrink-0 group overflow-hidden">
						<img
							src={`https://demo.riskydress.com/images/2026/AZURE/${item.images?.[0]}`}
							alt={item.style}
							className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
						/>
						<div className=" flex justify-center items-center  absolute bg-[#1f4c94]  bottom-3 font-lora right-3  text-white text-md px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300">
							{item.style}
							<span>
								<Icon
									icon="flowbite:arrow-right-outline"
									width="1.6rem"
									height="1.6rem"
									style={{ color: "white" }}
									className="ms-5 lg:block md:block hidden"
								/>
							</span>
						</div>
					</Link>
				))}
			</div>

			{/* Right Arrow */}
			<button
				onClick={() => scroll("right")}
				// ... (classes remain the same)
				className="absolute right-4 top-[60%] -translate-y-1/2 bg-[#1f4c94] shadow-md p-2 rounded-full z-10 hover:bg-[#1f4c94] transition">
				<Icon icon="mdi:chevron-right" className="text-3xl text-white" />
			</button>
		</div>
	);
}
